import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import {
  optionBuybackDetail,
  StateBuybackDetail,
} from "../types/OptionBuyback";
import { queryClient } from "./client";
import {
  buybackState,
  createOptionBuybackDetails,
  discardBuyback,
  exercisableDetail,
  getOptionBuybackDetails,
} from "../api/optionBuyback";
import { randomOfferList, randomOptionBuybackOverview } from "./placeholders";
import {
  completeOptionSplit,
  createOptionSplit,
  getOptionSplits,
} from "../api/optionSplit";

export function useGetOptionSplits() {
  return useQuery({
    queryKey: ["optionSplits"],
    queryFn: getOptionSplits,
  });
}

export function useCreateOptionSplit() {
  return useMutation({
    mutationKey: "createOptionSplit",
    mutationFn: createOptionSplit,
    onSuccess: () => {
      queryClient.invalidateQueries("optionSplits");
      queryClient.refetchQueries("optionSplits");
    },
    onError: () => {},
  });
}

export function useCompleteOptionSplit() {
  return useMutation({
    mutationKey: "completeOptionSplit",
    mutationFn: completeOptionSplit,
    onSuccess: () => {
      queryClient.invalidateQueries("optionSplits");
      queryClient.refetchQueries("optionSplits");
      toast("Split Completed", { type: "success" });
    },
    onError: () => {
      toast("Something Went Wrong", { type: "error" });
    },
  });
}
